module.exports = __webpack_public_path__ + "media/images/turbochargers/Holset-dbecfe8d34d385d9fd474e496a1a74f9.jpg";